require('prelude');
const $ = require('rgs-jquery');


const formConstructors = {
	'CALLBACK2': require('./js/callback'),
	'EMAILBACK': require('./js/emailback'),
};


module.exports = {
	createForModal: function (e, { productName }) {
		const $data = $('[data-cms-data-for-web-form="' + productName + '"]');
		const data = JSON.parse($data.html());
		const Form = formConstructors[productName];
		const instance = new Form(data);

		return {
			title: instance._title,
			template: {
				nodes: $.parseHTML(instance._modalTemplate),
				data: instance._model,
			},
		};
	},
};
